/**
 * Id of widget-base's own heading for a widget, which it always renders
 * itself (only hidden via CSS for some widget types). Used as the
 * aria-labelledby target, so it stays valid regardless of whether a
 * replacement heading is separately rendered by a child component.
 * @returns {string} The heading element id.
 */
export function getWidgetTitleId(widgetId: string): string {
  return 'h3' + widgetId;
}

/**
 * Id of the heading siat-widget-header renders for a widget. Only ever
 * used where widget-base's own "h3"-prefixed heading is CSS-hidden, so a
 * different, fixed prefix avoids a duplicate id collision between the two.
 * @returns {string} The heading element id.
 */
export function getWidgetHeaderComponentTitleId(widgetId: string): string {
  return 'h2' + widgetId;
}
